import React, { useState } from "react";
import "../../../style/landing.css";
import { landing_status } from "../constants/Constants_Var";
import { waitlist } from "../constants/Constants_Functions";
import WaitlistSection from "../waitlist/WaitlistSection";

const Subscribe = () => {
  const [email, setEmail] = useState("");

  return (
    <>
      <div className="lp-container">
        <div className="subscribe-container">
          <h1 className="lp-heading">Subscribe to Newslettr</h1>

          <p className="lp-heading-desc">
            Stay updated with the latest news, tips, and offers <br />
            by subscribing to our newslettr.
          </p>
          <WaitlistSection
            name={"inputwaitlist5"}
            email={email}
            setEmail={setEmail}
            waitlist={() => waitlist(email, setEmail, landing_status.waitlist)}
          />
        </div>
      </div>
    </>
  );
};

export default Subscribe;
